(function () {
  function planLines(words, width, count, measure) {
    if (count < 2 || count > 12 || words.length > 180) return null;
    var cache = new Map(), memo = new Map(), visits = 0;
    function lineWidth(a, b) {
      var key = a + ':' + b;
      if (!cache.has(key)) cache.set(key, measure(words.slice(a, b).join(' ')));
      return cache.get(key);
    }
    var average = (measure(words.join(' ')) - (count - 1) * measure(' ')) / count;
    function solve(start, remaining, ceiling) {
      if (++visits > 20000) return null;
      if (remaining === 0) return start === words.length ? { cost: 0, ends: [] } : null;
      if (words.length - start < remaining) return null;
      var key = start + ':' + remaining + ':' + ceiling.toFixed(2);
      if (memo.has(key)) return memo.get(key);
      var best = null;
      var target = average * (1.1 - 0.2 * (count - remaining) / (count - 1));
      for (var end = start + 1; end <= words.length - remaining + 1; end++) {
        var size = lineWidth(start, end);
        if (size > Math.min(width, ceiling) + 0.1) break;
        if (remaining === 1 && end !== words.length) continue;
        if (remaining > 1 && lineWidth(end, words.length) > (remaining - 1) * size + (remaining - 2) * measure(' ')) continue;
        var tail = solve(end, remaining - 1, size);
        if (!tail) continue;
        var cost = tail.cost + Math.pow((size - target) / Math.max(average, 1), 2);
        if (!best || cost < best.cost) best = { cost: cost, ends: [end].concat(tail.ends) };
      }
      memo.set(key, best);
      return best;
    }
    var result = solve(0, count, width);
    return result && result.ends;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = planLines;
    return;
  }

  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  if (!context) return;
  var widths = new WeakMap(), scheduled = false, ready = false;
  var observer = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    var changed = entries.some(function (entry) {
      var width = entry.contentRect.width;
      if (widths.get(entry.target) === width) return false;
      widths.set(entry.target, width);
      return true;
    });
    if (changed) schedule();
  }) : null;

  function clearBreaks(paragraph) {
    paragraph.querySelectorAll('br[data-sk-copy-break]').forEach(function (br) { br.remove(); });
    paragraph.normalize();
    paragraph.removeAttribute('data-sk-copy-lines');
  }

  function shape(paragraph) {
    clearBreaks(paragraph);
    paragraph.dataset.skCopyLayout = 'natural';
    if (paragraph.querySelector('br, img, svg, button, input')) return;
    var style = getComputedStyle(paragraph);
    if (style.textAlign !== 'center' || style.fontStyle !== 'italic') return;
    var width = paragraph.clientWidth;
    var height = paragraph.getBoundingClientRect().height;
    var panel = paragraph.closest('.skipstone-panel');
    var panelHeight = panel.getBoundingClientRect().height;
    var lineHeight = parseFloat(style.lineHeight);
    var count = Math.round(height / lineHeight);
    if (!width || !lineHeight || count < 2 || count > 12) return;
    var text = paragraph.textContent;
    var matches = Array.from(text.matchAll(/\S+/g));
    if (matches.length < count * 2) return;
    context.font = style.font;
    context.fontKerning = style.fontKerning;
    var tracking = parseFloat(style.letterSpacing) || 0;
    var measure = function (s) {
      return context.measureText(s).width + Math.max(0, s.length - 1) * tracking;
    };
    var words = matches.map(function (m) { return m[0]; });
    var plannedCount = count;
    var ends = planLines(words, width - 0.75, plannedCount, measure);
    if (!ends && count < 12) {
      plannedCount = count + 1;
      ends = planLines(words, width - 0.75, plannedCount, measure);
    }
    if (!ends) { paragraph.dataset.skCopyReason = 'whole-word-fit'; return; }
    var walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
    var nodes = [], node, offset = 0;
    while ((node = walker.nextNode())) {
      nodes.push({ node: node, start: offset, end: offset + node.length });
      offset += node.length;
    }
    ends.slice(0, -1).reverse().forEach(function (end) {
      var index = matches[end].index;
      var point = nodes.find(function (item) { return index >= item.start && index < item.end; });
      if (!point) return;
      var right = point.node.splitText(index - point.start);
      var br = document.createElement('br');
      br.dataset.skCopyBreak = '';
      right.before(br);
    });
    var rows = new Map();
    walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
    while ((node = walker.nextNode())) {
      var tokens = Array.from(node.textContent.matchAll(/\S+/g));
      tokens.forEach(function (token) {
        var range = document.createRange();
        range.setStart(node, token.index);
        range.setEnd(node, token.index + token[0].length);
        var rect = range.getBoundingClientRect();
        var top = Math.round(rect.top * 2) / 2;
        var row = rows.get(top) || { left: rect.left, right: rect.right };
        row.left = Math.min(row.left, rect.left);
        row.right = Math.max(row.right, rect.right);
        rows.set(top, row);
      });
    }
    var sizes = Array.from(rows.values()).map(function (row) { return row.right - row.left; });
    var valid = sizes.length === plannedCount && sizes.every(function (size, i) {
      return size <= width + 0.5 && (i === 0 || size <= sizes[i - 1] + 0.5);
    });
    if (!valid || Math.abs(panel.getBoundingClientRect().height - panelHeight) > 0.01 || paragraph.textContent !== text) {
      paragraph.dataset.skCopyReason = valid ? 'box-height' : 'rendered-lines';
      clearBreaks(paragraph);
      return;
    }
    paragraph.removeAttribute('data-sk-copy-reason');
    paragraph.dataset.skCopyLayout = 'tapered';
    paragraph.dataset.skCopyLines = sizes.map(function (n) { return n.toFixed(1); }).join(',');
  }

  function run() {
    scheduled = false;
    if (!ready) return;
    document.querySelectorAll('main .skipstone-panel .sk-panel-body').forEach(function (body) {
      if (observer) observer.observe(body);
      var paragraphs = body.querySelectorAll('p');
      if (paragraphs.length) paragraphs.forEach(shape);
      else if (!body.querySelector('div, ul, ol, blockquote')) shape(body);
    });
  }
  function schedule() {
    if (scheduled || !ready) return;
    scheduled = true;
    setTimeout(run, 0);
  }
  function init() {
    Promise.resolve(document.fonts && document.fonts.ready).then(function () {
      ready = true;
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.sk-panel-body').forEach(function (body) { if (observer) observer.unobserve(body); });
  });
})();
